import React from 'react';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  /** Désactive le ring/border au focus et le hover (ex. zone intégrée dans un bloc avec focus-within) */
  noFocusRing?: boolean;
  className?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label,
  error,
  icon,
  noFocusRing = false,
  className = '',
  ...props
}, ref) => {
  const focusStyles = noFocusRing
    ? 'focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none'
    : 'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent';

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
        </label>
      )}
      
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <div className="text-gray-400">
              {icon}
            </div>
          </div>
        )}
        
        <textarea
          ref={ref}
          className={`
            block w-full px-3.5 py-2.5 border border-gray-200 dark:border-gray-600 bg-white
            rounded-xl shadow-sm text-base sm:text-sm placeholder-gray-400 dark:placeholder-gray-500
            ${focusStyles}
            dark:bg-gray-700 dark:text-gray-100
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''}
            ${!error && !noFocusRing ? 'hover:border-gray-300' : ''}
            ${className}
          `}
          {...props}
        />
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600 dark:text-red-400">
          {error}
        </p>
      )}
    </div>
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;









